//@flow

import type {ProductModel} from "../../../productsearch/productApi";
import type {ProductStorage, PromotionSpecialPrice, SalesPromotion, ScalePrice} from "../../../service/productService";
import {LabeledPrice} from "../../../service/productService";
import {
	DETAILS_REQUEST,
	DETAILS_SUCCESS,
	PRODUCTS_REQUEST,
	PRODUCTS_SUCCESS
} from "../../../productsearch/actions/search";

export const WHEELS_MODAL = {
	SHOW: "WHEELS_MODAL_SHOW",
	HIDE: "WHEELS_MODAL_HIDE",
};

export const SPECIAL_WHEELS = {
	SELECT: "SPECIAL_WHEELS_SELECT",
};

export type SpecialsWheelsState = {
	isFetchingDetails: boolean,
	renderModal: boolean,
	requestId: string,
	products: ProductModel[],
	storages: ProductStorage[],
	salesPromotions: SalesPromotion[],
	scalePrices: ScalePrice[],
	specialPrices: PromotionSpecialPrice[],
	productDetailsOpen: any[],
	selectedWheel: ProductModel & LabeledPrice
}

const initialState: SpecialsWheelsState = {
	isFetchingDetails: false,
	renderModal: false,
	requestId: null,
	products: [],
	storages: [],
	salesPromotions: [],
	scalePrices: [],
	specialPrices: [],
	productDetailsOpen: [],
	selectedWheel: {},
};

export const specialsWheels = (state = initialState, action) => {
	switch (action.type) {
		case PRODUCTS_REQUEST:
			return {
				...state,
				hasSearched: false,
				isFetching: true,
				requestId: action.requestId
			};
		case PRODUCTS_SUCCESS:
			return state.requestId === action.requestId
				? {
					...state,
					products: [...action.products.content],
					page: action.products.number,
					totalItems: action.products.totalElements,
					totalPages: action.products.totalPages,
					isFetching: false,
					errorMessage: "",
					hasSearched: true,
				}
				: state;
		case DETAILS_REQUEST:
			return state.requestId === action.requestId
				? {
					...state,
					isFetchingDetails: true,
				}
				: state;
		case DETAILS_SUCCESS: {
			const storages = {};
			const salesPromotions = {};
			const scalePrices = {};
			const specialPrices = {};
			let products = state.products;
			action.response.forEach(detail => {
				storages[detail.partNumber] = detail.storage;
				salesPromotions[detail.partNumber] = detail.salesPromotions;
				scalePrices[detail.partNumber] = detail.scalePrices;
				specialPrices[detail.partNumber] = detail.specialPrices;
			});
			return {
				...state,
				products,
				scalePrices,
				specialPrices,
				storages,
				salesPromotions,
				isFetchingDetails: false,
				requestId: null
			};
		}
		case WHEELS_MODAL.SHOW: {
			return {
				...state,
				renderModal: true
			};
		}
		case WHEELS_MODAL.HIDE: {
			return {
				...state,
				renderModal: false
			};
		}
		case SPECIAL_WHEELS.SELECT: {
			return {
				...state,
				selectedWheel: {
					...action.payload.wheel,
					...action.payload.price
				}
			};
		}
		default:
			return state;
	}
};
